import _toConsumableArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import 'intersection-observer';
import { useEffect, useRef, useState } from 'react';
import useLayoutEffect from '@react-hook/passive-layout-effect';

var useIntersectionObserver = function useIntersectionObserver() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$root = options.root,
      root = _options$root === void 0 ? null : _options$root,
      _options$pollInterval = options.pollInterval,
      pollInterval = _options$pollInterval === void 0 ? null : _options$pollInterval,
      _options$useMutationO = options.useMutationObserver,
      useMutationObserver = _options$useMutationO === void 0 ? false : _options$useMutationO,
      _options$rootMargin = options.rootMargin,
      rootMargin = _options$rootMargin === void 0 ? '0px 0px 0px 0px' : _options$rootMargin,
      _options$threshold = options.threshold,
      threshold = _options$threshold === void 0 ? 0 : _options$threshold,
      _options$initialIsInt = options.initialIsIntersecting,
      initialIsIntersecting = _options$initialIsInt === void 0 ? false : _options$initialIsInt;

  function _ref(entries) {
    return setEntry(entries[entries.length - 1]);
  }

  var didMount = useRef(null),
      _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      element = _useState2[0],
      setElement = _useState2[1],
      _useState3 = useState(function () {
    return {
      boundingClientRect: null,
      intersectionRatio: 0,
      intersectionRect: null,
      isIntersecting: initialIsIntersecting,
      rootBounds: null,
      target: null,
      time: 0
    };
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      entry = _useState4[0],
      setEntry = _useState4[1],
      createObserver = function createObserver() {
    if (typeof IntersectionObserver === 'undefined') return null;
    var observer = new IntersectionObserver(_ref, {
      root: root,
      rootMargin: rootMargin,
      threshold: threshold
    }); // @ts-ignore

    // @ts-ignore
    observer.POLL_INTERVAL = pollInterval; // @ts-ignore

    // @ts-ignore
    observer.USE_MUTATION_OBSERVER = useMutationObserver;
    return observer;
  },
      _useState5 = useState(createObserver),
      _useState6 = _slicedToArray(_useState5, 2),
      observer = _useState6[0],
      setObserver = _useState6[1];

  useEffect(function () {
    if (didMount.current === false) didMount.current = true;else setObserver(createObserver());
    var current = didMount.current;
    return function () {
      current === true && observer && observer.disconnect();
    };
  }, [root, rootMargin, pollInterval, useMutationObserver].concat(_toConsumableArray(Array.isArray(threshold) === true ? threshold : [threshold])));

  function _ref2() {
    element && observer && observer.unobserve(element);
  }

  useLayoutEffect(function () {
    element && observer && observer.observe(element);
    return _ref2;
  }, [element, observer]);
  return [entry, setElement];
};

export default useIntersectionObserver;